<template>
  <!-- 新增或修改表单开始 -->
  <div>
    <el-dialog
      :title="banners.id == 0 ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="visible"
      @close="dialogClose"
    >
      <el-form
        ref="banners"
        :model="banners"
        label-width="100px"
        :rules="rules"
        @keyup.enter.native="newsSubmit()"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="banners.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <!-- <el-form-item label="描述">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="banners.description"
                    >
                    </el-input>
                </el-form-item> -->
        <!-- <el-form-item label="活动时间" prop="startTime">
                    <el-date-picker
                        size="small"
                        v-model="dateTimeArr"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="dateTimeChange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                </el-form-item> -->
        <!-- <el-form-item label="频道分类" prop="channelNo">
                    <el-select
                        v-model="banners.channelNo"
                        width="100"
                        clearable
                        placeholder="banner渠道"
                    >
                        <el-option
                            v-for="item in channelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <el-cascader
                        v-model="banners.channelNo"
                        :options="channelTree"
                        :show-all-levels="false"
                        clearable
                        :props="optionsTree"
                    ></el-cascader>
                </el-form-item> -->
        <!-- <el-form-item label="类型" prop="type">
                    <el-select
                        v-model="banners.type"
                        width="100"
                        clearable
                        placeholder="请选择类型"
                    >
                        <el-option
                            v-for="item in typeArrList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item label="跳转地址" prop="linkUrl">
          <el-input placeholder="请输入完整链接" v-model="banners.linkUrl">
            <!-- <template slot="prepend">http(https)://</template> -->
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="banners.sort"
            controls-position="right"
            :min="0"
            size="small"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item label="banner图片" prop="imageUrl">
          <el-upload
            class="upload"
            ref="upload"
            :action="uploadUrl"
            name="file"
            :limit="1"
            accept=".png,.jpg"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :auto-upload="false"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
            <el-button
              style="margin-left: 10px"
              size="small"
              type="success"
              @click="submitUpload"
              >上传到服务器</el-button
            >
            <div slot="tip" class="el-upload__tip">
              只能上传 .png .jpg图片，且不超过10MB
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="newsSubmit">提交</el-button>
          <el-button @click="visible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
  <!-- 新增或修改表单结束 -->
</template>

<script>
import { showcontent } from "@/utils/method.js";
export default {
  props: ["checkedBanner", "channelTree"],
  data() {
    // const checkLink = (rule, value, callback) => {
    //     if (this.banners.type === "1" && !value) {
    //         return callback(new Error("外链地址不能为空"));
    //     }
    // };
    return {
      visible: false,
      banners: {
        title: "",
        description: "",
        channelNo: "",
        type: "",
        channelRefType: "1",
        linkUrl: "",
        sort: 0,
        imageUrl: "",
      },
      categories: [],
      uploadUrl: "",
      fileList: [],
      // 日期时间选择器的绑定值
      dateTimeArr: [],
      typeArrList: [
        { name: "外链", id: "1" },
        { name: "新闻", id: "2" },
        { name: "活动", id: "3" },
        { name: "课程", id: "4" },
      ],
      // 级联选择框的配置
      optionsTree: {
        label: "channelName",
        value: "channelNo",
        checkStrictly: true,
        emitPath: false,
      },
      //提交表单验证规则
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change",
          },
        ],
        channelNo: [
          {
            required: true,
            message: "请选择频道分类",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        // sort: [
        //   {
        //     required: true,
        //     message: "请输入排序",
        //     trigger: "change",
        //   },
        // ],
        imageUrl: [
          {
            required: true,
            message: "请上传一张图片",
            trigger: "change",
          },
        ],
        linkUrl: [
          {
            required: true,
            message: "请输入跳转链接",
            trigger: blur,
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入活动开始时间和结束时间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    init(id) {
      this.banners.id = id || 0;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.banners.resetFields();
        this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
      });
      if (this.banners.id) {
        this.$nextTick(() => {
          Object.keys(this.banners).forEach((key) => {
            this.banners[key] = this.checkedBanner[key];
            if (
              this.banners[key] === this.checkedBanner.title ||
              this.banners[key] === this.checkedBanner.description
            ) {
              this.banners[key] = showcontent(
                showcontent(this.checkedBanner[key])
              );
            }
          });

          this.dateTimeArr.push(this.banners.startTime || "");
          this.dateTimeArr.push(this.banners.endTime || "");
          if (this.banners.imageUrl) {
            const obj = {
              url: this.banners.imageUrl,
            };
            this.fileList = [obj];
          }
        });
      }
    },
    // 关闭弹框时触发事件
    dialogClose() {
      this.fileList = [];
      this.dateTimeArr = [];
      this.banners.description = "";
    },
    // 点击提交按钮时触发
    newsSubmit() {
      this.$refs.banners.validate((valid) => {
        if (valid) {
          let obj = {
            ...this.banners,
            id:
              this.banners.id == undefined || this.banners.id == 0
                ? null
                : this.banners.id,
          };
          this.$ajaxPost(
            "/banner" + (this.banners.id === 0 ? "/save/open" : "/update"),
            obj
          ).then(({ data }) => {
            console.log(data);
            if (data.code === 0) {
              this.visible = false;
              this.$message.success(
                `${this.banners.id === 0 ? "添加成功!" : "更新成功!"}`
              );
              this.$emit("bannersUpdateList");
            }
          })
          .catch((error) =>{
            this.$message.error(error);
          } )
        } else {
          return false;
        }
      });
    },
    dateTimeChange(val) {
      console.log(val);
      if (val) {
        this.banners.startTime = val[0];
        this.banners.endTime = val[1];
      } else {
        this.banners.startTime = "";
        this.banners.endTime = "";
      }
    },
    // ==============图片上传相关方法=========
    submitUpload() {
      this.$refs.upload.submit();
    },
    // 从本地保存的上传目录中删除图片路径
    handleRemove(file, fileList) {
      this.banners.imageUrl = "";
    },
    handlePreview(file) {
      window.open(file.url, "_blank").location;
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 10;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt100M;
    },
    handleSuccess(response) {
	  console.log(response);
      if (response && response.status === 200) {
        console.log("文件上传成功返回结果：", response.data);
	    let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
        this.banners.imageUrl = url;
		console.log(this.banners.imageUrl)
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: center;
}
/deep/ .el-upload-list--picture {
  .el-upload-list__item {
    width: 92px;
    height: 92px;
  }
}
</style>